import styled from "@emotion/styled";

import { colorCssVars } from "src/theme/color";
import { TextSize, textSizeCss } from "src/theme/text";

export const SecondaryText = styled.span`
  ${textSizeCss[TextSize.s]};
  color: var(${colorCssVars.text.secondary});
`;
